import { get as apiGet, TYPE_BROOKLYN_JSON } from 'api-client'
import _get from 'lodash/get'
import _map from 'lodash/map'
import { createAuthForRequest } from 'services/auth'
import { createModel as createTileModel } from 'services/tile'

export const SEARCH_CONTENT_TYPES = {
  VIDEO: 'VIDEO',
  DEFAULT: 'VIDEO',
}

/**
 * The default response limit
 */
export const DEFAULT_LIMIT = 16

/**
 * Get the search auto complete
 * @param {Object} options The parameters
 * @param {import('immutable').Map} [options.auth] The auth object if the user is logged in
 * @param {String|String[]} [options.language] The request language
 * @param {String} [options.value] The search term for auto complete
 */
export async function getSearchAutocomplete (options = {}) {
  const {
    auth, language, value, gpse,
  } = options
  const qs = { searchTerm: value, language }
  if (gpse) qs.gpse = gpse // do not add gpse if 0 to preserve existing caching
  try {
    const { body } = await apiGet(
      'search/autocomplete',
      qs,
      {
        auth: createAuthForRequest({ auth, includeJwt: false }),
        languageShouldBeString: true,
      },
      TYPE_BROOKLYN_JSON,
    )
    return body
  } catch (e) {
    return {}
  }
}

export async function searchContent (options = {}) {
  const {
    user,
    searchTerm,
    contentType,
    limit = DEFAULT_LIMIT,
    page = 1,
    auth,
  } = options
  const contentTypeFilter = {
    [SEARCH_CONTENT_TYPES.VIDEO]: 'video',
  }[contentType || SEARCH_CONTENT_TYPES.DEFAULT]
  // Search returns 0 as the first page by default.
  // We do not want user's to see this so we control the offset here
  const offsetPage = page - 1

  const language = user.getIn(['data', 'language', 0], 'en')

  const res = await apiGet(
    `videos/search/${searchTerm}`,
    {
      p: offsetPage,
      pp: limit,
      language,
      // useNLS,
      contentType: contentTypeFilter,
    },
    { auth: createAuthForRequest({ auth, includeJwt: true }) },
    TYPE_BROOKLYN_JSON,
  )
  const body = _get(res, 'body', {})
  const data = {
    ...body,
    titles: _map(_get(body, 'titles') || [], (t) => createTileModel(t)),
    currentPage: _get(body, 'currentPage') + 1,
  }
  const results = { data, searchTerm }
  return results
}

export default {
  getSearchAutocomplete,
  searchContent,
}
